import React from 'react'
import { createGlobalStyle } from 'styled-components'
import { SnackbarProvider } from 'notistack'
import { IconButton, StylesProvider, Container } from '@material-ui/core'
import { Close } from '@material-ui/icons'
import 'sanitize.css/sanitize.css'

import { useUser } from 'context/user-context'

const AuthenticatedApp = React.lazy(() => import('./AuthenticatedApp'))
const UnauthenticatedApp = React.lazy(() => import('./UnauthenticatedApp'))

const App = () => {
  const user = useUser()
  const notistackRef = React.createRef()

  const GlobalStyle = createGlobalStyle`
    body {
      background-color: #eee;
    }
  `

  const handleCloseModal = key => (
    <IconButton onClick={() => notistackRef.current.closeSnackbar(key)}>
      <Close style={{ fill: '#fff' }} />
    </IconButton>
  )

  return (
    <StylesProvider injectFirst>
      <SnackbarProvider
        maxSnack={4}
        ref={notistackRef}
        action={handleCloseModal}
        autoHideDuration={4000}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
      >
        <React.Suspense fallback={<p>carregando...</p>}>
          <GlobalStyle />
          <Container>{user ? <AuthenticatedApp /> : <UnauthenticatedApp />}</Container>
        </React.Suspense>
      </SnackbarProvider>
    </StylesProvider>
  )
}

export default App
